/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useNavigate, useLocation } from "react-router-dom";
import { empty, errorResponse, prepareResponseData } from "../../Utilities/utils";
import { AuthContext } from "../Root/ProtectedRoute";

// css
import "../students/Students.css";

// api
import assessmentApi from "../../api/Assessment";

//components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import AppWrapper from "../../components/appWrapper/AppWrapper";
import { Toast } from "primereact/toast";
import FullPageLoader from "../../components/loader/FullPageLoader";
import TableLoading from "../../components/skeleton/TableLoading";
import { FaPlus } from "react-icons/fa";
import RatingIndexTable from "../../components/tables/primeTable/ratingIndices/RatingIndices";

const RatingIndices = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  //ref
  const toastTR = useRef(null);
  // states
  const [ratingData, setRatingData] = useState([]);
  const [ratingModalVisibility, setRatingModalVisibility] = useState(false);
  const [selectedRatingDetail, setSelectedRatingDetail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);

  useEffect(() => {
    if (!empty(location) && !empty(location.state)) {
      const paramState = !empty(location.state) ? location.state : {};
      let ratingAdded = !empty(paramState.ratingAdded)
        ? paramState.ratingAdded
        : false;
      let ratingUpdated = !empty(paramState.ratingUpdated)
        ? paramState.ratingUpdated
        : false;
      if (ratingAdded === true || ratingUpdated === true) {
        const actionType = ratingAdded
          ? "added"
          : ratingUpdated
          ? "updated"
          : "";
        paramState.ratingAdded = false;
        paramState.ratingUpdated = false;
        responseDialog(
          "success",
          "Success",
          `Rating ${actionType} successfully!`
        );
        if (!empty(location) && !empty(location.state)) {
          navigate(null, {
            replace: true,
            state: {
              ratingAdded: false,
              ratingUpdated: false,
            },
          });
        }
      }
    }
  }, []);
  useEffect(() => {
    // fetch classes
    try {
      getAllRatings();
    } catch (error) {
      responseDialog(
        "error",
        "Something went wrong",
        "Failed to load classes. Please try again later."
      );
      if (!empty(location) && !empty(location.state)) {
        navigate(null, {
          replace: true,
          state: { ratingAdded: false, ratingUpdated: false },
        });
      }
    }
  }, [user?._id]);

  // function to get all ratings
  const getAllRatings = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await assessmentApi.getRatings(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setRatingData([]);
      } else {
        const data =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : [];
        setRatingData(data);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  //alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  // delete rating
  const deleteRating = async () => {
    try {
      if (ratingModalVisibility) setRatingModalVisibility(false);
      if (!isActionLoading) setIsActionLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const ratingId =
        !empty(selectedRatingDetail) && !empty(selectedRatingDetail._id)
          ? selectedRatingDetail._id
          : "";
      const response = await assessmentApi.deleteRating(schoolId, ratingId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        const error_response =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Failed to delete rating";
        return responseDialog("error", "Something went wrong", error_response);
      }

      responseDialog(
        "success",
        "Success",
        `Rating, ${
          !empty(selectedRatingDetail.title) ? selectedRatingDetail.title : ""
        }, was deleted successfully!`
      );
      return getAllRatings();
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsActionLoading(false);
    }
  };

  //function to hide confirm modal
  const hideRatingModal = () => {
    setRatingModalVisibility(false);
  };

  //go to update rating page
  const goToUpdateRating = (data) => {
    const ratingId = !empty(data) && !empty(data._id) ? data._id : "";
    navigate(`/assessment/rating-index/${ratingId}/update`);
  };

  // delete rating
  const showDeleteRatingModal = (data) => {
    setSelectedRatingDetail(data);
    setRatingModalVisibility(true);
  };

  const ratingModalFooter = (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <Button
        label="No"
        icon="pi pi-times"
        style={{
          backgroundColor: "transparent",
          color: "#e65061",
          borderColor: "#e65061",
          borderWidth: 1,
        }}
        onClick={hideRatingModal}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        style={{
          backgroundColor: "transparent",
          color: "#389d17",
          borderColor: "#389d17",
          borderWidth: 1,
        }}
        onClick={deleteRating}
      />
    </div>
  );

  return (
    <>
      <AppWrapper {...props}>
        <main>
          <div className="tableCard">
            {/*  header start */}
            <MainHeader
              button
              buttonText="Add Rating Indice"
              link="/assessment/rating-index/add"
              title="Rating Indices"
              icon={<FaPlus />}
              iconMarginRight={5}
            />
            {/* end of header */}

            {/* table start */}
            {!isLoading ? (
              <RatingIndexTable
                ratingIndices={ratingData}
                goToUpdateRatingScreen={goToUpdateRating}
                goToDeleteRatingScreen={showDeleteRatingModal}
              />
            ) : (
              <TableLoading rows={20} cols={3} header={false} />
            )}
            {/* table end  */}
          </div>
        </main>
      </AppWrapper>
      {isActionLoading && <FullPageLoader visible={isActionLoading} />}

      <Dialog
        visible={ratingModalVisibility}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={ratingModalFooter}
        onHide={hideRatingModal}
      >
        <div
          className="confirmation-content"
          style={{ marginTop: 20, display: "flex", alignItems: "center" }}
        >
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem", marginRight: 15, color: "#e65061" }}
          />
          {
            <span>
              Are you sure you want to delete the selected rating index?
            </span>
          }
        </div>
      </Dialog>
      <Toast ref={toastTR} style={{ zIndex: 99999 }} position="bottom-left" />
    </>
  );
};

export default RatingIndices;
